module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Italic.8dc8105d.ttf";